{
    "Profile_CommonComponents_Message.needHelp": "Need help with your quote?",
    "Profile_CommonComponents_Message.directMessage": "Send me a direct message from ",
    "Profile_CommonComponents_Message.messagesPage": "your messages page",
    "Profile_CommonComponents_Message.orCall": "or call ",
    "Profile_CommonComponents_Message.phoneNumber": "1-888-6-COVERA",
    "Profile_CommonComponents_Message.title": "I have prepared this quote for you.",
    "Profile_CommonComponents_Message.signature": "Talk to you soon,",
    "Profile_CommonComponents_Message.save": "Save",
    "Profile_CommonComponents_Message.reply": "Reply"
}
